<h1 mat-dialog-title> Detalle Rechazo Solicitud por Compañia externa</h1> <br/>

<mat-dialog-content>
    <p>
        <mat-form-field appearance = "outline" class = "mat-input">

            <mat-label> Folio Externo: </mat-label>
            
            <input matInput placeholder = "folio" [(ngModel)] = "data.numDocumento" required [disabled] = "true"> 

        </mat-form-field>
    </p>
    
    <p>
        <mat-form-field appearance = "outline" class = "mat-input">

            <mat-label> Fecha Respuesta compañia: </mat-label>
            <input matInput placeholder = "fecha Respuesta" [(ngModel)] = "data.fechaRespuesta"  [disabled] = "true"> 
           
        </mat-form-field>
    </p>

    <p>
        <mat-form-field appearance = "outline" class = "mat-input">

            <mat-label>Estado compañia externo: </mat-label>
            <input matInput placeholder = "estado" [(ngModel)] = "data.estado"  [disabled] = "true"> 
           
        </mat-form-field>
    </p>
   
    <p>
        <mat-form-field appearance = "outline" class = "mat-input">

            <mat-label> Comentario rechazo compañia: </mat-label>
            
            <input matInput placeholder = "Comentario Rechazo" required [disabled] = "true"> 
            <textarea disabled style=" min-width:500px; max-width:100%;min-height:50px;height:100%;width:100%;" rows="2">{{data.motivoRechazo}}</textarea>

        </mat-form-field>
    </p>
   
   
</mat-dialog-content>

<div mat-dialog-actions>

    <button mat-button class = "mat-raised-button btn-dark mat-button" (click) = "onCancelarClick()"> 
        <i class = "fa fa-sign-out-alt"> </i> Salir
    </button>
    
</div>